import { Fragment, ReactElement } from 'react';
import { Skeleton, Typography } from '@mui/material';

import { useStyles } from './useStyles';

interface IPoolNameCellProps {
  name?: string;
  icon?: string;
  labels?: string[];
  iconClassName?: string;
  additionalContent?: ReactElement;
  align?: 'left' | 'right';
}

export function InfoCellContent({
  name,
  icon,
  labels,
  iconClassName,
  additionalContent,
  align = 'left',
}: IPoolNameCellProps): ReactElement {
  const { classes, cx } = useStyles();
  const isAlignRight = align === 'right';

  return (
    <div className={classes.root}>
      <div className={classes.pool}>
        <div className={cx(classes.imageContainer, iconClassName)}>
          {icon ? (
            <img alt="" className={classes.image} src={icon} />
          ) : (
            <Skeleton
              sx={{ transform: 'none', width: '100%', height: '100%' }}
            />
          )}
        </div>

        <div className={cx(isAlignRight && classes.rightContent)}>
          <Typography component="div" variant="body1">
            {name || <Skeleton />}
          </Typography>

          <div className={classes.labels}>
            {labels?.map((label, i) => (
              <Fragment key={label}>
                {i !== 0 && <div className={classes.circle} />}

                <Typography component="div" variant="subtitle2">
                  {label}
                </Typography>
              </Fragment>
            ))}
          </div>
        </div>
      </div>

      {additionalContent}
    </div>
  );
}
